import styled, { css } from "styled-components";
import colours from "assets/colours";
import queries from "utils/responsivenessHelper";
import { fonts } from "assets/fontStyles";

const NavWrapper = styled.div`
  width: 100%;
  background-color: ${colours.zltoDarkBlue};
  display: flex;
  flex: 1;
`;

const NavList = styled.ul`
  list-style-type: none;
  padding: 0;
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const NavItem = styled.li`
  display: flex;
  flex-direction: row;
  padding: 12px 0px 12px 49px;
  text-align: center;

  ${queries.both({
    paddingLeft: "28px",
  })}
`;

const NavLink = styled.div`
  display: flex;
  align-items: center;
  ${fonts.link}
  cursor: pointer;

  &,
  a {
    font-weight: 600;
    font-size: 1.0625em;
    line-height: 166%;
    color: ${colours.white};

    &:hover {
      color: ${colours.zltoLightBlue};
    }
  }
`;

const IconWrapper = styled.div`
  margin-right: 15px;
  svg {
    circle {
      fill: ${colours.zltoLightBlue};
    }
    path {
      fill: ${colours.zltoLightBlue};
    }
  }

  ${({ active }) =>
    !active &&
    css`
      svg {
        circle {
          fill: ${colours.white};
        }
        path {
          fill: ${colours.white};
        }
      }
    `}
`;

const BottomNavItem = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
`;

export { NavWrapper, NavList, NavItem, NavLink, IconWrapper, BottomNavItem };
